import { useMutation, useQueryClient } from 'react-query';
import * as R from 'ramda';
import PESService from 'App/services/PESService';
import { stripAllHtml } from 'App/utils';

function useUpdatePatientProfileNotesMutation(patientId) {
    const queryClient = useQueryClient();
    return useMutation(
        ({ uuid, note, important }) =>
            PESService.updatePatientProfileNotes(patientId, uuid, {
                note: stripAllHtml(note),
                important,
            }),
        {
            onMutate: async (updatedNote) => {
                await queryClient.cancelQueries(['patient', patientId, 'notes']);

                const previousNotes = queryClient.getQueryData(['patient', patientId, 'notes']);

                queryClient.setQueryData(['patient', patientId, 'notes'], (oldNotes) => {
                    if (!oldNotes) return [updatedNote];
                    const index = R.findIndex(R.propEq(updatedNote.uuid, 'uuid'), oldNotes);
                    return R.update(index, R.mergeRight(oldNotes[index], updatedNote), oldNotes);
                });

                return { previousNotes };
            },
            onSuccess: (updatedNoteResponse, variables) => {
                // Update cache with the actual API response that includes the updated timestamp
                queryClient.setQueryData(['patient', patientId, 'notes'], (oldNotes) => {
                    return oldNotes.map((note) => (note.uuid === variables.uuid ? updatedNoteResponse : note));
                });
            },
            onError: (_err, _updatedNote, context) => {
                queryClient.setQueryData(['patient', patientId, 'notes'], context.previousNotes);
            },
        }
    );
}

export default useUpdatePatientProfileNotesMutation;
